module.exports = __webpack_public_path__ + "static/media/c16.be428869.png";